// components/module/compras/components/NotificationSnackbars.tsx
import React from 'react';
import { Snackbar, Alert } from '@mui/material';

interface NotificationSnackbarsProps {
  successMessage: string;
  errorMessage: string | null;
  showSuccess: boolean;
  onSuccessClose: () => void;
  onErrorClose: () => void;
}

const NotificationSnackbars: React.FC<NotificationSnackbarsProps> = ({
  successMessage,
  errorMessage,
  showSuccess,
  onSuccessClose,
  onErrorClose,
}) => (
  <>
    <Snackbar
      open={showSuccess}
      autoHideDuration={6000}
      onClose={onSuccessClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={onSuccessClose} 
        severity="success"
        variant="filled"
      >
        {successMessage}
      </Alert>
    </Snackbar>

    <Snackbar
      open={!!errorMessage}
      autoHideDuration={6000}
      onClose={onErrorClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={onErrorClose} 
        severity="error"
        variant="filled"
      >
        {errorMessage}
      </Alert>
    </Snackbar>
  </>
);

export default NotificationSnackbars;